const esTranslation = require('./es.json')
const esSurveyTranslation = require('./esSurveys.json')

const newTranslation = { ...esSurveyTranslation, ...esTranslation }

export default newTranslation
